import {Fragment, useRef} from 'react';
import '../assets/css/product-card.css';
import { MiniClose } from '../../assets/icones/icones';
import { useSelector, useDispatch } from 'react-redux';
import { addToCart, decreaseQuantity, removeProduct, increaseQuantity } from '../../redux/cartredux/actions';
import {FormatNumberByhkh} from "../../clientconfigwebapp";
import {toast} from "react-toastify";



const ProductCard = (props) => {
    const cartItems = useSelector(state => state.cartItems);
    const dispatch = useDispatch();
    const count = cartItems.find(item => item.id === props.data_full_curent_item.id_post);

    const item = {
        id: props.data_full_curent_item.id_post,
        title: props.data_full_curent_item.title_post,
        price: props.data_full_curent_item.price,
        quantity: 1
    }
    //
    // const item = {
    //     id: props.data_full_curent_item.id_post,
    //     title: props.title,
    //     price: props.price,
    //     quantity: 1
    // }

    const handleAddToCart = (product) => {
        dispatch(addToCart(product));

        toast.success('با موفقیت به سبد خرید اضافه شد', {position: "top-center", autoClose:4000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});

    };

    const handleDecreaseQuantity = (productId) => {
        dispatch(decreaseQuantity(productId));
    };
    const handleIncreaseQuantity = (productId) => {



        const i = cartItems.find(item => item.id);

        console.log(i,"bbbbbbbb");
        console.log(item.id,"itttttttteeeeeeemmmmmm4");


       //// if (!i) {   handleAddToCart(item);  console.log(item,"aaaaaaaawwwww33333333333"); }else{ dispatch(increaseQuantity(productId)); console.log(productId,"aaaaaaaawwwww4444444444")  }

        handleAddToCart(item);






    };
    const handleRemoveProduct = (productId) => {
        dispatch(removeProduct(productId));
    };
    const btnContentHandler = (productId) => {
        const i = cartItems.find(item => item.id === productId);
        if (i && i.quantity === 1) {
            handleRemoveProduct(productId)
        } else {
            handleAddToCart(item)
        }
    }
    const handleMinus = () => {
        const i = cartItems.find(item => item.id === props.data_full_curent_item.id_post);
        if (i && i.quantity > 1) {
            handleDecreaseQuantity(props.data_full_curent_item.id_post)
        }else if(i && i.quantity === 1){
            handleRemoveProduct(props.data_full_curent_item.id_post)
        }
    }
    const btnContent = () => {

        const i = cartItems.find(item => item.id === props.data_full_curent_item.id_post);
        return 'افزودن';
        if (i && i.quantity > 0) {
            return 'حذف از سبد خرید'
        } else {
            return 'افزودن'
        }


    }
    const quantityContent = () => {
        const i = cartItems.find(item => item.id === props.data_full_curent_item.id_post);
        if (i) {
            return i.quantity
        } else {
            return 0
        }
    }

    const modal = useRef(null)
    return (
        <>
            <div  className='flexColStartStart product-modal-container modal_animation_bk_2' ref={modal}>


                <div className={"modal-bg-bk"}  onClick={ () => { modal.current.classList.toggle('active'); }}   ></div>

                <div className={"content-modalbk"}>
                    <section onClick={() => modal.current.classList.toggle('active')}>
                        <MiniClose color={'#000'}/>
                    </section>
                    <div style={{"display":"flex","alignContent":"center","justifyContent":"center","alignItems":"center","flexDirection":"column"}}><img src={props.data_full_curent_item.image_src} alt={props.data_full_curent_item.title_post}
                              className='w-100'/></div>
                    <h3>{props.data_full_curent_item.title_post}</h3>
                    <span>
                        <span> {FormatNumberByhkh(String(props.data_full_curent_item.price), ".", ",")}</span>
                    </span>
                    <p className='w-100'>{props.data_full_curent_item.summary_text}</p>
                    <div className='w-100 flexRowBetCenter'>

                        <button onClick={() => handleIncreaseQuantity(props.data_full_curent_item.id_post)}>{btnContent()}</button>

                        {/*<button onClick={() => btnContentHandler(props.data_full_curent_item.id_post)}>{btnContent()}</button>*/}
                        {/*{count &&*/}
                            <div className='flexRowStartCenter'>
                                <button onClick={() => handleMinus()}>-</button>
                                <span>{quantityContent()}</span>
                                <button onClick={() => handleIncreaseQuantity(props.data_full_curent_item.id_post)}>+</button>
                            </div>
                        {/*}*/}
                    </div>
                </div>
            </div>
            <div className='w-100 product-card-container'>



                <div className='w-100 flexRowStartCenter product-card-img-container' onClick={() => modal.current.classList.toggle('active')}>

                    <figure className="snip1256">
                        <img src={props.data_full_curent_item.image_src} alt={props.data_full_curent_item.title_post} />
                        <figcaption>
                            <p className='w1-100 flexColCenterCenter'>{props.data_full_curent_item.summary_text}</p>
                        </figcaption>
                    </figure>



                </div>
                <h3 onClick={() => handleRemoveProduct(props.data_full_curent_item.id_post)}>
                    {props.data_full_curent_item.off > 0 ? <span className='pro-off'>{props.data_full_curent_item.off}%</span> : null}
                    {props.data_full_curent_item.title_post}
                </h3>

                <div className='w-100 flexRowBetCenter'>


                    {
                        props.data_full_curent_item.off > 0 ?
                            <Fragment>

                                <div className={"box_full_price_off"}>
                                    <span className={"price_main_off"}><del> {FormatNumberByhkh(String(props.data_full_curent_item.price_line), ".", ",")}</del></span><span className={"price_off"}>{FormatNumberByhkh(String(props.data_full_curent_item.price), ".", ",")}</span>
                                </div>

                            </Fragment>
                            :
                            <Fragment>
                                <div className={"box_full_price_off"}>
                                    <span className={"price_main_card"}> {FormatNumberByhkh(String(props.data_full_curent_item.price), ".", ",")}</span>
                                </div>

                            </Fragment>
                    }




                    <button onClick={() => handleAddToCart(item)} >+ افزودن</button>
                </div>
            </div>
        </>
    );
}
export default ProductCard;